// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails');

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import LocalTime from 'local-time';

import '~/web-components';
import '~/user-cards/index';

import '~/listeners/sl-dialog-show';
import '~/listeners/on-submit-update-dom';

import { AuthFlow } from '~/auth-flow';
import { GoogleSignIn } from '~/auth-flow/google-sign-in';
import { MessageDialog } from '~/messages/message-dialog';
import { ScreenTransitions } from '~/shared/utils/screen-transitions';
import { ServiceView } from '~/services/service-view';
import { ServiceRequestDialog } from '~/services/service-request-dialog';
import { SiteNav } from '~/globals/site-nav';
import { SiteFooter } from '~/globals/site-footer';
import { Turbo } from '@hotwired/turbo-rails';

Turbo.config.forms.mode = 'off';
Turbo.session.drive = false;

// Prevent Turbo from hijacking history navigation and adding unnecesary event listeners.
// We still want to use Turbo Streams, so we disable everything else.
// See source code at: https://github.com/hotwired/turbo/blob/71a769167eb64fafed48fe45ed175a54738216af/src/core/session.js#L74
Turbo.session.pageObserver?.stop();
Turbo.session.cacheObserver?.stop();
Turbo.session.linkPrefetchObserver?.stop();
Turbo.session.formLinkClickObserver?.stop();
Turbo.session.linkClickObserver?.stop();
Turbo.session.formSubmitObserver?.stop();
Turbo.session.scrollObserver?.stop();
Turbo.session.frameRedirector?.stop();
Turbo.session.history?.stop();
Turbo.session.preloader?.stop();
Turbo.session.started = false;

GoogleSignIn.init();
AuthFlow.init();
ScreenTransitions.init();
SiteNav.init();
ServiceView.init();
ServiceRequestDialog.init();
MessageDialog.init();
SiteFooter.init();

LocalTime.start();
